import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/common/common.service";
import { WorkflowManagementContent } from "../../../modules/settings/components/workflow-management/workflow-management-content/workflow-management-content.component";
import SettingsHead from "../../../modules/settings/shared/settings-head/settings-head.component";
import { Box } from "@material-ui/core";
import { GlobalContext } from "../../../store";

export default function WorkflowManagementPage() {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.WORKFLOW_MANAGEMENT"));
      setPageTitle(t("PAGE_META_TITLES.WORKFLOW_MANAGEMENT"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="role-contain">
      <Box className="content">
        <SettingsHead
          title={t("PAGES_HEAD.SETTINGS.WORKFLOW_MANAGEMENT_TITLE")}
          subTitle={t("PAGES_HEAD.SETTINGS.WORKFLOW_MANAGEMENT_SUB_TITLE")}
        />
        <WorkflowManagementContent />
      </Box>
    </Box>
  );
}
